import { createSelector } from 'reselect';

const getGradebookCategories = (state) => state.gradebook.categories;
const getGradebookCategoryWeights = (state) => state.gradebook.categoryWeights;

const filterUngradedCategory = createSelector(
  [getGradebookCategories],
  (categories) =>
    categories.filter((category) => !category.is_default_ungraded),
);

const joinWeightsAndCategories = (categories, weights) => {
  weights.forEach((weight) => {
    const index = categories.findIndex((cat) => cat.id === weight.category_id);
    if (index !== -1) {
      categories[index].weight = weight.weight;
    }
  });
  return categories;
};

export const selectGradebookCategories = createSelector(
  [getGradebookCategories, getGradebookCategoryWeights],
  joinWeightsAndCategories,
);

export const selectGradebookCategoriesAndFilterUngradedCategory =
  createSelector(
    [filterUngradedCategory, getGradebookCategoryWeights],
    joinWeightsAndCategories,
  );

export const selectDefaultCategory = createSelector(
  [getGradebookCategories],
  (categories) => categories.find((category) => category.is_default),
);
